import axiosService from "../api/axios";

export const getHealthPlacesService = (params: any) => {
  return axiosService.get("/hp?" + new URLSearchParams({ ...params }));
};
